import { Col } from 'reactstrap';

const PhoneNotification = ({ phoneScreen, selectedFile, selectedButtons = ['accept'], imageUrl }) => {
    const displayImageUrl = imageUrl || (selectedFile ? URL.createObjectURL(selectedFile) : null);

    return (
        <Col lg={3}>
            <div style={{ maxWidth: '60%', margin: '0 auto' }}>
                <img src={phoneScreen} alt="Phone Mockup" style={{ width: "100%", height: "auto" }} />
                
                <div style={{
                    position: 'absolute',
                    top: '35%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#ffffff',
                    color: '#ff0000',
                    padding: '10px 15px',
                    borderRadius: '5px',
                    textAlign: 'center',
                    height: 'auto',
                    minHeight: '30%',
                    width: '70%',
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '200px'
                }}>
                    {/* Notification Image */}
                    {displayImageUrl && (
                        <div style={{ marginBottom: '10px', flex: 1 }}>
                            <img 
                                src={displayImageUrl}
                                alt="Notification Image" 
                                style={{ 
                                    width: '100%', 
                                    maxHeight: '100px',
                                    objectFit: 'contain'
                                }} 
                            />
                        </div>
                    )}
                    
                    {/* Notification Buttons */}
                    <div style={{ 
                        position: 'absolute',
                        bottom: '-20px',
                        left: '0',
                        width: '100%',
                        display: 'flex', 
                        justifyContent: 'space-between',
                        borderRadius: '5px'
                    }}>
                        {/* Cancel butonu */}
                        <button style={{ 
                            background: 'white', 
                            flex: '1', 
                            height: '25px', 
                            borderColor: 'transparent', 
                            fontSize: '9px', 
                            display: selectedButtons.includes('cancel') ? 'block' : 'none' 
                        }}>
                            Cancel
                        </button>
                        
                        {/* Accept butonu */}
                        <button style={{ 
                            background: 'white', 
                            flex: '1', 
                            height: '25px', 
                            borderColor: 'transparent', 
                            fontSize: '9px' 
                        }}>
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </Col>
    );
};

export default PhoneNotification;